import './style.scss';

import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import Modal from './tools/modal';
import Viewer from './tools/viewer';
import Filter from './tools/filters';

/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */
const routes = new Router({
	/** All pages */
	common,
	/** Home page */
	home,
});

/**
 * Initialize Filters System
 */
const modalFilters = new Filter();

/**
 * Initialize Modal System
 */
const modalSystem = new Modal();

/**
 * Initialize Viewer System
 */
const viewerSystem = new Viewer();

// Export for global access if needed
window.OutpressModal = modalSystem;
window.OutpressViewer = viewerSystem;
window.OutpressFilters = modalFilters;

/** Load Events */
document.addEventListener('DOMContentLoaded', () => routes.loadEvents());